import { useFetch } from "@hooks/useFetch";
import { getProspectReference } from "@utils/storage";
import { clearCartRoute } from "@api-routes/eirSalesFacade";
import { getStateToPayload } from "@features/cart/mappers/clearCartMapper";
import { useContext } from "react";
import { NumberOfferContext } from "../../../App";

export const useClearCart = () => {
    const [clearCartState, { deleteCall }] = useFetch();
    const { setNumberOfferSelected } = useContext(NumberOfferContext);

    const callClearCart = (): Promise<void> =>
        deleteCall<void>(clearCartRoute(getProspectReference()), {
            body: getStateToPayload(),
        }).then(() => {
            setNumberOfferSelected(0);
        });

    return { clearCartState, callClearCart };
};
